<div class="saas-background">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-6 py-5">
        <p class="text-white link-casestudy">
          <span (click)="nav('/')">Home</span> /
          <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span>
        </p>
        <h1 class="py-3 saas-heading">
          Kalpita Data Obfuscation to improve data security
        </h1>
        <p class="py-3 saas-para">
          The fundamental idea behind creating this data obfuscation tool to
          enhance the data security. It transforms sensitive or personally
          identifiable information (PII) into a non-sensitive and anonymous
          form.
        </p>
      </div>
      <!-- <div class="col-md-6">
        <img
          src="../../../../assets/casestudies/mob-saas.webp"
          class="img-fluid mobile-saas cross-mobile"
          alt="mobileimgs"
        />
        <span class="straigt-mobile"
          ><img
            class="img-fluid mobile-saas"
            src="../../../../assets/casestudies/mobile-straight.webp"
            alt="mobstraight"
        /></span>
      </div> -->
    </div>
  </div>
</div>
<!-- The challenge...................................................................... -->
<div class="challenge-background">
  <div class="container">
    <div class="row py-5">
      <div class="col-md-6">
        <h5 class="challenge-head py-1">Problem</h5>
      <p class="py-3">
        Data risk has become highly common with the advanced technologies, and
        everything being digitalized. The need to protect sensitive data has
        become significant.
      </p>

      <h5 class="challenge-head py-1">Objective</h5>
      <p class="py-3">
        The core objective was to create a tool to enhance data security &
        confidentiality, and to obfuscate the client-provided data.
      </p>
      </div>

      <div class="col-md-6 bg-white p-5">
        <h5 class="challenge-head">Solution</h5>
        <p class="py-3">
          We created Kalpita Data Obfuscation tool that can safeguard sensitive
          data and mask confidential information. The data obfuscation method used
          in this tool masks the confidential data by replacing it with symbols,
          numbers, or alphabets.
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Solution............................................... -->
<div class="">
  <div class="container">
    <div class="row py-5">      
      <div class="col-md-6">
        <h5 class="challenge-head">The Kalpita Data Obfuscation tool benefits you with, </h5>
        <ul>
          <li class="ico-img">Improved Security & Confidentiality </li>
          <li class="ico-img">Efficient Data Processing  </li>
          <li class="ico-img">Mapping Tables </li>
          <li class="ico-img">Intuitive Admin Page  </li>
          <li class="ico-img">User-Defined Functions </li>
          <li class="ico-img">Keyword Management </li>
        </ul>
      </div>

      <div class="col-md-6">
        <img src="../../../../assets/resources/casestudies/obf-casestudy-soln.webp" class="img-fluid"
        alt="obf-solution">
      </div>
      
    </div>
  </div>
</div>
